import React, { useRef, useState, useMemo, useEffect } from "react";
import { apiQueryWithToken, apiQueryWithTokenRegional } from "../../common/services/apiBaseUrlConfig";
import {
  MotifButton,
  MotifTable,
  MotifLabel,
  MotifFormField,
  MotifOption,
  MotifSelect,
} from "@ey-xd/motif-react";
import { TableHeader } from "./TableHeader";
import { useNavigate } from "react-router-dom";
import { MotifProgressLoader } from "@ey-xd/motif-react";
import { Stepper } from "../stepper/stepper";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent";
import { getAccount } from "../../common/services/commonService";
import useGetApplicationData from "../../common/redux/common/getApplicationData/useGetApplicationData";
import { getApplicationData } from "../../common/redux/common/getApplicationData/getApplicationDataSlice";
import { useDispatch } from "react-redux";

import "./fileUpload.scss";
import { AMERICAS, APAC, EMEIA, PARTNER } from "../../common/contants/constants";
import logger from "../../common/utils/logger";

export const FileUpload = () => {
  const [searchValue, setSearchValue] = useState("");
  const [fileData, setFileData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [sectorId, setSectorId] = useState(0);
  const [subsectorId, setSubsectorId] = useState(0);
  const [subSubsectorId, setSubSubsectorId] = useState(0);
  const [functions, setFunctions] = useState("");
  const [marketSize, setMarketSize] = useState("");
  const [isSaveEnabled, setIsSaveEnabled] = useState(false);
  const [selectedRow, setSelectedRow] = useState(0);
  const [sslCompetancy, setSslCompetancy] = useState("");
  const [ isAnonymizing, setIsAnonymizing ] = useState(false);
  const [ baseURL, setBaseURL] = useState("");

  const {getApplicationDetail, loading, error } = useGetApplicationData();
  const filteredData = Object.values(
    fileData?.filter((item) => {
      return (
        item?.fileName?.toLowerCase().includes(searchValue.toLowerCase()) ||
        item?.engagementId?.toString().includes(searchValue) || // Convert engagementId to string for comparison
        item?.uploaded_By?.toLowerCase().includes(searchValue.toLowerCase())
    );
    })
  );

  
    useEffect(() => {
    if(window.location.host.indexOf('uksucbsdbrwap01') === 0 || window.location.host.indexOf('data-bureau-uat') === 0){
      if(selectedRow?.area === AMERICAS){
        setBaseURL("https://data-bureau-uat-us.sbp.eyclienthub.com")
       } else if (selectedRow?.area === EMEIA){
        setBaseURL("https://data-bureau-uat-eu.sbp.eyclienthub.com")
       } else if (selectedRow?.area === APAC){
        setBaseURL("https://data-bureau-uat-aus.sbp.eyclienthub.com")
       }
     
    } else {
      if(selectedRow?.area === AMERICAS){
        setBaseURL("https://usedcbsdbrwap03.azurewebsites.net")
       } else if (selectedRow?.area === EMEIA){
        setBaseURL("https://euwdcbsdbrwap01.azurewebsites.net")
       } else if (selectedRow?.area === APAC){
        setBaseURL("https://auedcbsdbrwap02.azurewebsites.net")
       }
    }
    
    }, [selectedRow?.area])

  useEffect(() => {
    getData();
    const intervalId = setInterval(getData, 300000);
    return () => clearInterval(intervalId);
  }, []);

  const gridRef = useRef();
  const navigation = useNavigate();
  const dispatch = useDispatch();
  
  useEffect(() => {
        const cachedData = sessionStorage.getItem("userDataCache"); // Check session storage for cached data
        if (cachedData) {
          // If data exists in session storage, use it
          if (cachedData) {
            setUserData(JSON.parse(cachedData)); // Assuming the data is stored as a JSON string
          }
        } else {
          // If no cached data, make the API call using Redux dispatch
  if(!getApplicationDetail || Object.keys(getApplicationDetail).length === 0) {
          dispatch(getApplicationData());
  }
          if (
            getApplicationDetail &&
            Object.keys(getApplicationDetail).length > 0
          ) {
            setUserData(getApplicationDetail);
  
            // Store fetched data in session storage for future use
            sessionStorage.setItem(
              "userDataCache", // Key for user data in session storage
              JSON.stringify(getApplicationDetail)
            );
          } else if (error) {
            navigation("/"); // Redirect if unauthorized
          }
        }
      }, [dispatch, getApplicationDetail, error, navigation]);


  const onFilterTextBoxChanged = (value) => {
    setSearchValue(value);
  };

  const subSector = useMemo(() => {
    if (subsectorId > 0) {
      return userData?.subSectorLists?.find((item) => {
        return item.subsectorID === subsectorId;
      })?.subSectorName;
    } else {
      return "";
    }
  }, [subsectorId]);

  const sector = useMemo(() => {
    if (sectorId > 0) {
      return userData?.sectors?.find((item) => {
        return item.sectorId === sectorId;
      })?.sectorName;
    } else {
      return "";
    }
  }, [sectorId]);

  const subSubsector = useMemo(() => {
    if (subSubsectorId > 0) {
      return userData?.subSubSectorLists?.find((item) => {
        return item.subSubSectorID === subSubsectorId;
      })?.subSubSectorName;
    } else {
      return "";
    }
  }, [subSubsectorId]);

  const onSaveClick = () => {
    setIsLoading(true);
    apiQueryWithToken
      .post(`api/fileupload/edit`, {
        UserEmailID: getAccount()?.username,
        UserID: selectedRow?.controlid,
        Revenue: marketSize,
        Sector: sector,
        SubSector: subSector,
        subSubSector: subSubsector,
        subSubSectorId: subSubsectorId,
        sectorId: sectorId,
        subSectorId: subsectorId,
        Function: functions,
        Config_File: selectedRow?.config,
        SSLCompetancy: sslCompetancy,
      })
      .then((data) => {
        setIsEditModalOpen(false);
        setIsLoading(false);
        window.location.reload();
      })
      .catch((error) => {
        setIsLoading(false);
        if (error.response && error.response.status === 401) {
          navigation("/");
        } else {
          logger.error("An error occurred:", error);
        }
      });
  };

  const onEditModalClose = () => {
    setIsEditModalOpen(false);
  };

  const onModalClose = () => {
    setShowModal(false);
  };

  const onEditClick = (id) => {
    setIsSaveEnabled(false);
    const rowData = fileData?.filter((row) => {
      return row.controlid === id;
    });
    setSelectedRow(rowData[0]);
    setSectorId(rowData[0].sectorId);
    setSubsectorId(rowData[0].subSectorId);
    setSubSubsectorId(rowData[0].subSubSectorID);
    
    setFunctions(rowData[0].function);
    setMarketSize(rowData[0].marketSize);
    setSslCompetancy(rowData[0].sslCompetancy);
    setIsEditModalOpen(true);
  };

  const onAnonymizeConfirmClick = () => {
    setIsAnonymizing(true);
   
    apiQueryWithTokenRegional
      .post(`${baseURL}/api/fileupload/FileTransfer`, {
        emailId: getAccount()?.username,
        fileName: selectedRow?.mapping_FileName,
        region: selectedRow?.area,
        NewRegion: selectedRow?.region,
        country: selectedRow?.country
      })
      .then((data) => {
        setIsAnonymizing(false);
        setShowModal(false);
        window.location.reload();
      })
      .catch((error) => {
        setIsLoading(false);
        if (error.response && error.response.status === 401) {
          navigation("/");
        } else {
          logger.error("An error occurred:", error);
        }
      });
  };

  const onAnonymizationClick = (id) => {
    const rowData = fileData?.filter((row) => {
      return row.controlid === id;
    });
    setSelectedRow(rowData[0]);
    setShowModal(true);
  };

  const actionCellRenderer = ({ value }) => {
    const rowData = fileData?.filter((row) => {
      return row.controlid === value;
    });

    const renderIcons = () => {
      if (rowData[0]?.userRole === PARTNER && !rowData[0]?.actionButtonFlag) {
        return (
          <>
            <div
              className="edit-icon"
              title="Edit File Details"
              onClick={() => onEditClick(value)}
            >
              <img
                src={require("../../common/images/edit_enable_icon.png")}
                alt="edit-enable-icon"
              />
            </div>
            {rowData[0]?.region &&
              rowData[0]?.country &&
              rowData[0]?.sector &&
              rowData[0]?.subSector &&
              rowData[0]?.subSubSector &&
              rowData[0]?.marketSize &&
              rowData[0]?.function &&
              rowData[0]?.sslCompetancy ? (
              <div
                title="Start Anonymization"
                className="anonymize-icon"
                onClick={() => onAnonymizationClick(value)}
              >
                <img
                  src={require("../../common/images/anonymize_enable_icon.png")}
                  alt="anonymize-enable-icon"
                />
              </div>
            ) : (
              <div
                title="Start Anonymization"
                className="anonymize-icon-disabled"
              >
                <img
                  src={require("../../common/images/anonymize_disable_icon.png")}
                  alt="anonymize-disable-icon"
                />
              </div>
            )}
          </>
        );
      }
      return (
        <>
          <div className="edit-icon-disabled" title="Edit File Details">
            <img
              src={require("../../common/images/edit_disable_icon.png")}
              alt="edit-disable-icon"
            />
          </div>
          <div title="Start Anonymization" className="anonymize-icon-disabled">
            <img
              src={require("../../common/images/anonymize_disable_icon.png")}
              alt="anonymize-disable-icon"
            />
          </div>
        </>
      );
    };

    return <div className="actions">{renderIcons()}</div>;
  };

  const getData = () => {
    setIsLoading(true);
    apiQueryWithToken
      .get(`api/fileupload`)
      .then((data) => {
        setFileData(data?.data);
        setIsLoading(false);
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          navigation("/");
        } else {
          logger.error("An error occurred:", error);
          setIsLoading(false);
        }
      });
  };

  const columnDefs = [
    {
      field: "controlid",
      headerName: "ID",
      width: 80,
    },
    {
      field: "clientName",
      headerName: "Client Name",
      width: 130,
    },
    {
      field: "engagementId",
      headerName: "Engagement Id",
      width: 150,
    },
    {
      field: "projectName",
      headerName: "Project Name",
      width: 150,
    },
    {
      cellRenderer: fileNameCellRenderer,
      field: "fileName",
      headerName: "File Name",
    },
    {
      field: "fileType",
      headerName: "File Type",
      width: 120,
    },
    {
      field: "area",
      filter: true,
      headerName: "Area",
      width: 120,
    },
    {
      field: "region",
      filter: true,
      headerName: "Region",
      width: 120,
    },
    {
      field: "country",
      filter: true,
      headerName: "Country",
      width: 130,
    },
    {
      field: "sector",
      filter: true,
      headerName: "Sector",
      width: 120,
    },
    {
      field: "subSector",
      filter: true,
      headerName: "Subsector",
      width: 140,
    },
    {
      field: "subSubSector",
      filter: true,
      headerName: "Sub-Sub Sector",
      width: 170,
    },
    {
      field: "function",
      filter: true,
      headerName: "Function",
      width: 130,
    },
    {
      field: "marketSize",
      filter: true,
      headerName: "Revenue Range",
      width: 170,
    },
    {
      field: "sslCompetancy",
      filter: true,
      headerName: "SSL Competency",
      width: 190,
    },
    {
      cellRenderer: dotCellRenderer,
      field: "upload_status",
      headerName: "Upload Status",
      width: 150,
    },
    {
      field: "uploaded_By",
      headerName: "Uploaded By",
      width: 250,
    },
    {
      field: "lastupdatedon",
      headerName: "Last Updated On",
      width: 250,
    },
    {
      field: "userRole",
      headerName: "User Role",
      width: 130,
    },
    {
      cellRenderer: actionCellRenderer,
      field: "controlid",
      headerName: "Actions",
      width: 180,
    },
  ];

  return (
    <div className="fileUpload-container">
      <div className="page-title-wrap">
        <h3>File Upload</h3>
      </div>
      <Stepper />
      {filteredData && (
        <div className="grid-wrapper">
          <TableHeader
            onFilterTextBoxChanged={onFilterTextBoxChanged}
            searchValue={searchValue}
            navigation={navigation}
          />
          <div className="grid-container">
            <div className={"ag-theme-quartz grid-container-inner"}>
              {isLoading ? (
                <MotifProgressLoader show variant="default" />
              ) : (
                <MotifTable
                  columnDefs={columnDefs}
                  variant="alt"
                  description="Descriptive text that describes your page or content."
                  name="Default"
                  pagination
                  paginationPageSize={10}
                  paginationPageSizeSelector={[3, 4, 5]}
                  rowData={filteredData}
                  zebra={false}
                />
              )}
              <Dialog
                onClose={onEditModalClose}
                open={isEditModalOpen}
                className="admin-dialog"
              >
                <DialogTitle>
                  <img
                    src={require("../../../src/common/images/update_icon.png")}
                  />
                  <div className="heading">{`Update Details`}</div>
                </DialogTitle>

                <IconButton
                  onClick={onEditModalClose}
                  sx={{
                    position: "absolute",
                    right: 8,
                    top: 8,
                  }}
                >
                  <CloseIcon />
                </IconButton>

                <DialogContent dividers className="modal-content">
                  <div className="fileName">File - {selectedRow?.fileName}</div>
                  <div className="first-step">
                    <div className="field">
                      <MotifLabel>Sector</MotifLabel>
                      <MotifFormField key={"sector"}>
                        {userData?.sectors?.length > 0 && (
                          <MotifSelect
                            key={sectorId}
                            ariaLabelledBy="select-label"
                            onChange={(value) => {
                              value !== sectorId && setIsSaveEnabled(true);
                              setSectorId(value);
                              setSubsectorId(0);
                              setSubSubsectorId(0);
                            }}
                            placeholder="Select"
                            value={sectorId ? sectorId : ""}
                            triggerButtonProps={{
                              "aria-describedby": "select-error-reactive",
                            }}
                          >
                            {userData?.sectors?.map((item) => {
                              return (
                                <MotifOption
                                  key={item.sectorId}
                                  value={item.sectorId}
                                >
                                  {item.sectorName}
                                </MotifOption>
                              );
                            })}
                          </MotifSelect>
                        )}
                      </MotifFormField>
                    </div>
                    <div className="field">
                      <MotifLabel>Subsector</MotifLabel>
                      <MotifFormField key={"subsector"}>
                        {userData?.subSectors?.length > 0 && (
                          <MotifSelect
                            key={subsectorId}
                            ariaLabelledBy="select-label"
                            onChange={(value) => {
                              value !== subsectorId && setIsSaveEnabled(true);
                              setSubsectorId(value);
                              setSubSubsectorId(0);
                            }}
                            placeholder="Select"
                            value={subsectorId ? subsectorId : ""}
                            triggerButtonProps={{
                              "aria-describedby": "select-error-reactive",
                            }}
                          >
                            {userData?.subSectorLists
                              ?.filter((subSector) => {
                                return subSector.sectorId === sectorId;
                              })
                              .map((item) => {
                                return (
                                  <MotifOption
                                    key={item.subsectorID}
                                    value={item.subsectorID}
                                  >
                                    {item.subSectorName}
                                  </MotifOption>
                                );
                              })}
                          </MotifSelect>
                        )}
                      </MotifFormField>
                    </div>
                    <div className="field">
                      <MotifLabel>Sub-Sub Sector</MotifLabel>
                      <MotifFormField key={"subSubsector"}>
                        {userData?.subSubSectorLists?.length > 0 && (
                          <MotifSelect
                            key={subSubsectorId}
                            ariaLabelledBy="select-label"
                            onChange={(value) => {
                              value !== subSubsectorId &&
                                setIsSaveEnabled(true);
                              setSubSubsectorId(value);
                            }}
                            placeholder="Select"
                            value={subSubsectorId ? subSubsectorId : ""}
                            triggerButtonProps={{
                              "aria-describedby": "select-error-reactive",
                            }}
                          >
                            {userData?.subSubSectorLists
                              ?.filter((subSubSector) => {
                                return subSubSector.subsectorID === subsectorId;
                              })
                              .map((item) => {
                                return (
                                  <MotifOption
                                    key={item.subSubSectorID}
                                    value={item.subSubSectorID}
                                  >
                                    {item.subSubSectorName}
                                  </MotifOption>
                                );
                              })}
                          </MotifSelect>
                        )}
                      </MotifFormField>
                    </div>
                    <div className="field">
                      <MotifLabel>Revenue Range</MotifLabel>
                      <MotifFormField key={"marketSize"}>
                        {userData?.revenueRanges?.length > 0 && (
                          <MotifSelect
                            key={marketSize}
                            ariaLabelledBy="select-label"
                            onChange={(value) => {
                              value !== marketSize && setIsSaveEnabled(true);
                              setMarketSize(value);
                            }}
                            placeholder="Select"
                            value={marketSize ? marketSize : ""}
                            triggerButtonProps={{
                              "aria-describedby": "select-error-reactive",
                            }}
                          >
                            {userData?.revenueRanges?.map((item) => {
                              return (
                                <MotifOption
                                    key={item.range}
                                    value={item.range}
                                  >
                                    {item.range}
                                  </MotifOption>
                              );
                            })}
                          </MotifSelect>
                        )}
                      </MotifFormField>
                    </div>
                    <div className="field">
                      <MotifLabel>Function</MotifLabel>
                      <MotifFormField key={"function"}>
                        {userData?.functions?.length > 0 && (
                          <MotifSelect
                            key={functions}
                            ariaLabelledBy="select-label"
                            onChange={(value) => {
                              value !== functions && setIsSaveEnabled(true);
                              setFunctions(value);
                            }}
                            placeholder="Select"
                            value={functions ? functions : ""}
                            triggerButtonProps={{
                              "aria-describedby": "select-error-reactive",
                            }}
                          >
                            {userData?.functions?.map((item) => {
                              return (
                                <MotifOption
                                  value={item.functionName}
                                  key={item.functionName}
                                >
                                  {item.functionName}
                                </MotifOption>
                              );
                            })}
                          </MotifSelect>
                        )}
                      </MotifFormField>
                    </div>
                    <div className="field">
                      <MotifLabel>SSL Competency</MotifLabel>
                      <MotifFormField key={"sslCompetancy"}>
                        <MotifSelect
                          key={"sslCompetencySelect"}
                          ariaLabelledBy="select-label"
                          onChange={(value) => {
                            value !== sslCompetancy && setIsSaveEnabled(true);
                            setSslCompetancy(value);
                          }}
                          placeholder="Select"
                          value={sslCompetancy ? sslCompetancy : ""}
                          triggerButtonProps={{
                            "aria-describedby": "select-error-reactive",
                          }}
                        >
                          {/* Hardcoded options */}
                          <MotifOption key="TCF-TD" value="TCF-TD">
                            TCF - TD
                          </MotifOption>
                          <MotifOption key="TCF-VME" value="TCF-VME">
                            TCF - VME
                          </MotifOption>
                          <MotifOption key="TCF-LA" value="TCF-LA">
                            TCF - LA
                          </MotifOption>
                          <MotifOption key="EYP-Strategy" value="EYP-Strategy">
                            EYP - Strategy
                          </MotifOption>
                          <MotifOption key="EYP-TSE" value="EYP-TSE">
                            EYP - TSE
                          </MotifOption>
                          <MotifOption key="EYP-TRS" value="EYP-TRS">
                            EYP - TRS
                          </MotifOption>
                        </MotifSelect>
                      </MotifFormField>
                    </div>
                  </div>
                </DialogContent>
                <DialogActions>
                  <MotifButton
                    onClick={onEditModalClose}
                    size="medium"
                    type="button"
                    variant="secondary"
                  >
                    Cancel
                  </MotifButton>
                  {
                    <MotifButton
                      onClick={onSaveClick}
                      size="medium"
                      type="button"
                      disabled={!isSaveEnabled}
                    >
                      Save
                    </MotifButton>
                  }
                </DialogActions>
              </Dialog>
              <Dialog
                onClose={onModalClose}
                open={showModal}
                className="admin-dialog"
              >
                <DialogTitle>
                  <img
                    src={require("../../../src/common/images/anonymize_dialog_icon.png")}
                  />
                  <div className="heading">Start Anonymization</div>
                </DialogTitle>

                <IconButton
                  onClick={onModalClose}
                  sx={{
                    position: "absolute",
                    right: 8,
                    top: 8,
                  }}
                >
                  <CloseIcon />
                </IconButton>

                <DialogContent dividers className="modal-content">
                  <div className="fileName">File - {selectedRow?.fileName}</div>
                  {
                    <span>
                      Please click on Confirm if you want to start anonymization
                      of this file.
                    </span>
                  }
                   {isAnonymizing && <MotifProgressLoader show variant="default" />}
                </DialogContent>
                <DialogActions>
                  <MotifButton
                    onClick={onModalClose}
                    size="medium"
                    type="button"
                    variant="secondary"
                  >
                    Cancel
                  </MotifButton>
                  {
                    <MotifButton
                      onClick={onAnonymizeConfirmClick}
                      size="medium"
                      type="button"
                    >
                      Confirm
                    </MotifButton>
                  }
                </DialogActions>
              </Dialog>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const fileNameCellRenderer = ({ value }) => {
  return (
    <div className="fileNameLink">
      {" "}
      <a href="#">{value}</a>
    </div>
  );
};

const dotCellRenderer = ({ value }) => {
  const showStatus = value?.replace(/\s/g, "").toLowerCase();
  return (
    <div
      className={`motif-dot ${showStatus === "inprogress" && "motif-dot-left"
        } ${(showStatus === "success" || showStatus === "completed") &&
        "motif-dot-success"
        } ${showStatus === "failed" && "motif-dot-error"} ${showStatus === "inprogress" && "motif-dot-warning"
        }`}
    >
      <span className="motif-dot-text">{value}</span>
    </div>
  );
};
